module.exports = __webpack_public_path__ + "media/images/flags/sd-242211e5aa42d80a4ae725546ce88f2b.png";